// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"484":"999b493abc116a1c","2888":"c364ddc8ef62ec5d"}[chunkId] + ".css";
};